__turbopack_context__.v({
  "info": "styles-module-scss-module__Uv3z7a__info",
  "page404": "styles-module-scss-module__Uv3z7a__page404",
});
